import { PixelIcon } from "./PixelIcon";

export type HardwareKey = "A" | "B" | "C";

export interface HardwareButtonsProps {
  retro: boolean;
  onPress(key: HardwareKey): void;
}

export function HardwareButtons({ retro, onPress }: HardwareButtonsProps) {
  return (
    <div className="hw" id="hw" data-testid="hardware-buttons">
      <div className="hwb">
        <button
          className="hw-btn"
          data-k="A"
          data-testid="hw-prev"
          type="button"
          aria-label={retro ? "Previous care action" : undefined}
          aria-hidden={retro ? undefined : "true"}
          tabIndex={retro ? 0 : -1}
          onClick={() => onPress("A")}
        >
          <PixelIcon name="prev" />
        </button>
        <span className="hwl" aria-hidden="true">
          PREVIOUS
        </span>
      </div>
      <div className="hwb">
        <button
          className="hw-btn"
          data-k="B"
          data-testid="hw-do"
          type="button"
          aria-label={retro ? "Do the selected care action" : undefined}
          aria-hidden={retro ? undefined : "true"}
          tabIndex={retro ? 0 : -1}
          onClick={() => onPress("B")}
        >
          <PixelIcon name="check" />
        </button>
        <span className="hwl" aria-hidden="true">
          DO IT
        </span>
      </div>
      <div className="hwb">
        <button
          className="hw-btn"
          data-k="C"
          data-testid="hw-next"
          type="button"
          aria-label={retro ? "Next care action" : undefined}
          aria-hidden={retro ? undefined : "true"}
          tabIndex={retro ? 0 : -1}
          onClick={() => onPress("C")}
        >
          <PixelIcon name="next" />
        </button>
        <span className="hwl" aria-hidden="true">
          NEXT
        </span>
      </div>
    </div>
  );
}
